import $ from 'jquery';
import View from 'mixins/view';
import AbstractComment from '@ui/comments/comments-views/abstract-comment';
import AddCommentView from '@ui/comments/add-comment-view';
import { repository } from 'repositories/loadCommentsAsync';
import shoutboxRepository from '@ui/shoutbox/repository';
import LikeCommentsAsync from 'repositories/likeCommentsAsync';
import DeleteRepository from 'repositories/deleteCommentsAsync';
import SaveRepository from 'repositories/saveCommentsAsync';
import RecommendCommentRepository from 'repositories/recommendCommentsAsync';
import ReportCommentRepository from 'repositories/reportCommentsAsync';
import BanRepository from 'repositories/banRepository';
import { siteModel } from 'models/SiteModel';
import CommentsService from '@ui/comments/CommentService';
import { pluralVariety } from '@utils/translations';
import ShoutboxPaginator from '@ui/shoutbox/paginator';
import SponsorPlayerComment from '@ui/comments/comments-views/sponsor-player-comment';
import SponsorTotoComment from '@ui/comments/comments-views/sponsor-toto-comment';
import SponsorIplaComment from '@ui/comments/comments-views/sponsor-ipla-comment';
import { buildCommentSocioTippies } from '@ui/comments/comment-socio-view';

export const elements = {
    commentsList: '.comments-list__base',
    addCommentView: '.c-comments__main',
    modal: ".comments-modal",
    liveBanner: ".c-comments__new-link.c-comments__new-link--base",
    config: ".c-comments-config",
    loadMore: ".c-comments__loadMore",
    formContainer: '.comment-textfield'
};

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(elements.commentsList));
        this.noCommentsYetEl = `
            <p class="comments-list__no-comments">
                ` + $(elements.commentsList).data('no-comments') + `
            </p>
        `;
        this.liveCommentsTrigger = $(`<a href="#" class="c-comments__new-link c-comments__new-link--base hide"></a>`);
        model.addEventListener('loaded', this::this.render);
        this.buildAddCommentView();

        buildCommentSocioTippies(elements.commentsList);

        /**
         * Handle backend errors in comments sections
         *
         * @param {*} item - item object details
         *                   id, parentCommentId
         * @param {*} error - error response
         *                    message
         */
        const dispatchCommentErrorEvent = (item, error) => {
            /*
            * @TODO
            * - convert into event
            */
            const message = error.message;
            const id = item.id ? item.id : false;
            const root = item.parentCommentId ? item.parentCommentId : true;

            const $error = $(`
                <div class="gl-error-pocket">
                    <ul class="text-color_red-size_tiny">
                        <li> ${message} </li>
                    </ul>
                </div>`);

            let $errorWrapper = $('#c-comments').find(`.comment-error-wrapper[data-id=${id}]`);
            if (!id) {
                $errorWrapper = $errorWrapper.filter(`[data-root=${root}]`);
            }
            $errorWrapper.html($error).show();

            setTimeout(() => {
                $errorWrapper.hide();
            }, 3000);
        };

        const sendDirectCommentRefreshEvent = (id, detail) => {
            const selector = `article.user-comment[data-id=${id}]`;
            const $comment = $(selector);

            if ($comment.length) {
                $comment.get(0).dispatchEvent(new CustomEvent('RefreshComment', { detail }));
            }
        };

        const setCommentBeforeAction = (id) => {
            const selector = `article.user-comment[data-id=${id}]`;
            const $comment = $(selector);

            const $loader = $comment.find('.c-comments__loader-container').first();
            if ($loader.length) {
                $loader.empty().append('<img src="/img/ui/comments/loader.svg" />').show();
            }
        };

        const setCommentAfterAction = (id) => {
            const selector = `article.user-comment[data-id=${id}]`;
            const $comment = $(selector);

            const $loader = $comment.find('.c-comments__loader-container').first();
            if ($loader.length) {
                $loader.empty().hide();
            }
        };

        const handleChangeModerationMode = (event) => {
            const User = siteModel.get('User');
            const { isInModerationMode } = event.detail;
            const properties = Object.assign(User.properties, {
                isInModerationMode,
            });

            siteModel.set('User', Object.assign(User, { properties }));
            siteModel.get('User').fireEvent('changedModerationMode');

            this.toggleModerationMode();
            this.render();
        };
        document.addEventListener('ChangedModerationMode', handleChangeModerationMode);

        // Reaguje na event z prośbą o dodanie nowego komentarza
        // Wykonuje call do API
        // Jeżeli komentarz dodano pomyślnie puszcza event
        // success, jeżeli nie to failure
        const saveRepository = new SaveRepository();
        const handleAddBaseComment = (event) => {
          saveRepository
            .save(event.detail.item)
            .then((data) => {
              const successAdded = new CustomEvent('AddBaseCommentSuccess', {
                detail: data,
              })
              document.dispatchEvent(successAdded);
            })
            .catch((error) => {
              document.dispatchEvent(new CustomEvent('AddBaseCommentFailure', {
                detail: { error }
              }));
              dispatchCommentErrorEvent(event.detail.item, error);
            })
            .then(() => {
              $(elements.formContainer).removeClass('is-loading');
            });
        };
        document.addEventListener('AddBaseComment',
          handleAddBaseComment,
          false);

        const handleAddBaseCommentSuccess = (event) => {
          const newCommentId = event.detail.commentId;
          const filter = CommentsService.getVisibleCommentsCollection()
            .get('filter');
          const commentsLength = CommentsService
            .getVisibleCommentsCollection()
            .get('comments').length;

          if (CommentsService.isShoutboxMode()) {
            const filters = { type: 'latest', page: 1 };
            CommentsService.setShoutboxParams(filters);

            CommentsService.updateCollection(function(data) {
              /**
               * @TODO
               * verify shoutbox paginator render
               */
              // ShoutboxPaginator.render(data.pager);
            });
          }
          else
          {
            if (commentsLength === 0 || filter !== 'date') {
              document.dispatchEvent(new CustomEvent('ChangeCommentFilter', { detail: 'date' }));
              CommentsService.updateCollection();
            } else {
              repository.load(filter)
                .then((data) => {
                  CommentsService.getBufferCommentsCollection()
                    .fromJSON(data.comments);
                  CommentsService.loadBaseCommentFromBufferById(newCommentId);
                  const model = CommentsService.getVisibleCommentsCollection()
                    .findById(newCommentId);
                  this.addCommentToTop(model);
                  this.liveCommentsTrigger.addClass('hide');
                });
            }
          }
        }
        document.addEventListener('AddBaseCommentSuccess',
          handleAddBaseCommentSuccess,
          false);

        const handleEditComment = (event) => {
          saveRepository
            .edit(event.detail.item)
            .then((data) => {
              const successEdited = new CustomEvent('EditCommentSuccess', {
                detail: {
                  // when API works ID should be from data.commentId
                  commentId: event.detail.item.id,
                },
              })
              document.dispatchEvent(successEdited);
            })
            .catch(error => {
              dispatchCommentErrorEvent(event.detail.item, error);
            })
            .then(() => {
              $(elements.formContainer).removeClass('is-loading');
            });
        };
        document.addEventListener('EditComment', handleEditComment, false);

        const handleEditCommentSuccess = (event) => {
          const id = event.detail.commentId;

          const request = getRepositoryWithParameters();
          request.repository.load(request.parameters)
            .then((data) => {
              CommentsService.getBufferCommentsCollection()
                .fromJSON(data.comments);
              const oldModel = CommentsService
                .getVisibleCommentsCollection()
                .findById(id);
              const newModel = CommentsService
                .getBufferCommentsCollection()
                .findById(id);
              if (oldModel && newModel) {
                oldModel.update(newModel);
                sendDirectCommentRefreshEvent(id, { id });
              }
            });
        }
        document.addEventListener('EditCommentSuccess', handleEditCommentSuccess, false);

        const handleAddReplyComment = (event) => {
          saveRepository
            .save(event.detail.item)
            .then((data) => {
              const successAdded = new CustomEvent('AddReplyCommentSuccess', {
                detail: {
                  parentCommentId: event.detail.item.parentCommentId,
                  id: data.commentId,
                },
              })
              document.dispatchEvent(successAdded);
            })
            .catch(error => {
              dispatchCommentErrorEvent(event.detail.item, error);
            }).then(() => {
              $(elements.formContainer).removeClass('is-loading');
            });
        };
        document.addEventListener('AddReplyComment',
          handleAddReplyComment,
          false);

        const getRepositoryWithParameters = () => {
          const filter = CommentsService.getVisibleCommentsCollection()
            .get('filter');
          let result = {
            repository,
            parameters: filter
          }

          if (CommentsService.isShoutboxMode()) {
            const ids = CommentsService.getShoutboxBaseComments();
            const params = CommentsService.getShoutboxParams();

            result.repository = shoutboxRepository;
            result.parameters = { type: 'live', ids, last: params.last };
          }
          return result;
        }

        const handleAddReplyCommentSuccess = (event) => {
          const parentCommentId = parseInt(event.detail.parentCommentId);
          const newCommentId = event.detail.id;

          const request = getRepositoryWithParameters();
          request.repository.load(request.parameters)
            .then((data) => {
              CommentsService.getBufferCommentsCollection()
                .fromJSON(data.comments);

              const bufferParentModel = CommentsService
                .getBufferCommentsCollection()
                .findById(parentCommentId);

              const visibleParentModel = CommentsService
                .getVisibleCommentsCollection()
                .findById(parentCommentId);

              visibleParentModel.update(bufferParentModel);

              document.dispatchEvent(new CustomEvent('RefreshRepliesList', {
                detail: {
                  parentCommentId,
                  newCommentId,
                  newCommentModel: CommentsService
                    .getVisibleCommentsCollection()
                    .findById(newCommentId),
                }
              }));
            });
        };
        document.addEventListener('AddReplyCommentSuccess',
          handleAddReplyCommentSuccess,
          false);

        /*
         * Comments like - start events
         */

        const likeRepository = new LikeCommentsAsync();
        const handleLikeComment = (event) => {
            const { id, value } = event.detail;
            const action = value ? 'unlike' : 'like';

            setCommentBeforeAction(id);
            likeRepository[action](id)
                .then(data => {
                    document.dispatchEvent(new CustomEvent('LikeCommentSuccess', {
                        detail: { id, data },
                    }));
                }).catch(data => {
                    dispatchCommentErrorEvent(event.detail, data);
                    /*
                    * @TODO
                    * - UpdateDeletedComment
                    */
                }).finally(() => {
                  setCommentAfterAction(id);
                });
        };
        document.addEventListener('LikeComment', handleLikeComment);

        const handleLikeCommentSuccess = (event) => {
            const { id, data } = event.detail;
            const commentModel = CommentsService.getVisibleCommentsCollection().findById(id);

            if (commentModel) {
                commentModel.vote(data);
                sendDirectCommentRefreshEvent(id, { id, model: commentModel });
            }
        };
        document.addEventListener('LikeCommentSuccess', handleLikeCommentSuccess);

        /*
         * Comments like - end events
         */

        /*
         * Comments delete - start events
         */

        const deleteRepository = new DeleteRepository();
        const handleDeleteCommment = (event) => {
            const { id, isDeleted } = event.detail;
            const action = isDeleted ? 'undelete' : 'delete';

            setCommentBeforeAction(id);
            deleteRepository[action](id)
                .then((updatedModel) => {
                    document.dispatchEvent(new CustomEvent('DeleteCommentSuccess', {
                        detail: { id, updatedModel },
                    }));
                }).catch((data) => {
                    dispatchCommentErrorEvent(event.detail, data);
                    /*
                     * @TODO
                     * - UpdateDeletedComment
                     */
                }).finally(() => {
                  setCommentAfterAction(id);
                });
        };
        document.addEventListener('DeleteComment', handleDeleteCommment);

        const handleDeleteCommentSuccess = (event) => {
            const id = event.detail.id;
            const commentModel = CommentsService.getVisibleCommentsCollection().findById(id);

            /*
             * @TODO
             * - in moderator when change view, comments sometimes are not updated
             * - debug buffered / visible comments
             */
            if (commentModel) {
                commentModel.delete(event.detail.updatedModel);
                sendDirectCommentRefreshEvent(id, { id, model: commentModel });
            }
        };
        document.addEventListener('DeleteCommentSuccess', handleDeleteCommentSuccess);

        /*
         * @TODO
         * - debug handleUpdateDeletedComment
         */
        const handleUpdateDeletedComment = (event) => {
            const detail = event.detail;
            CommentsService.updateDeletedComment(detail.commentInfo);

            if (!siteModel.get('User').isInModerationMode()) {
                const commentModel = CommentsService.getVisibleCommentsCollection().findById(detail.id);
                if (commentModel) {
                    sendDirectCommentRefreshEvent(detail.id, {
                        id: detail.id,
                        model: commentModel,
                        message: detail.message,
                    });
                }
            }
        };
        document.addEventListener('UpdateDeletedComment', handleUpdateDeletedComment);

        /*
         * Comments delete - end events
         */

        /*
         * Comments recommend - start events
         */

        const recommendCommentAsync = new RecommendCommentRepository();
        const handleRecommendComment = (event) => {
            const { id, isRecommended } = event.detail;
            const action = isRecommended ? 'unrecommend' : 'recommend';

            setCommentBeforeAction(id);
            recommendCommentAsync[action](id)
                .then((data) => {
                    document.dispatchEvent(new CustomEvent('RecommendCommentSuccess', {
                        detail: { id, isRecommended: data.isRecommended },
                    }));
                }).finally(() => {
                  setCommentAfterAction(id);
                });
        };
        document.addEventListener('RecommendComment', handleRecommendComment);

        const handleRecommendCommentSuccess = (event) => {
            const { id, isRecommended } = event.detail;
            const commentModel = CommentsService.getVisibleCommentsCollection().findById(id);

            if (commentModel) {
                commentModel.set('isRecommended', isRecommended);
                sendDirectCommentRefreshEvent(id, { id, model: commentModel });
            }
        };
        document.addEventListener('RecommendCommentSuccess', handleRecommendCommentSuccess);

        /*
         * Comments recommend - end events
         */

        /*
         * Comments reporting - start events
         */

        const handleReportCommentSuccess = (id, isFlaggedByUser) => {
            const commentModel = CommentsService.getVisibleCommentsCollection().findById(id);

            if (commentModel) {
                commentModel.set('isFlaggedByUser', isFlaggedByUser);
                sendDirectCommentRefreshEvent(id, { id, model: commentModel });
            }
        };

        const reportCommentsRepository = new ReportCommentRepository();
        const handleReportComment = (event) => {
            const { id, isFlaggedByUser } = event.detail;
            const action = isFlaggedByUser ? 'unflag' : 'flag';

            setCommentBeforeAction(id);
            reportCommentsRepository[action](id)
                .then((data) => {
                    handleReportCommentSuccess(id, data.isFlaggedByUser);
                }).catch((data) => {
                    dispatchCommentErrorEvent(event.detail, data);
                    /*
                     * @TODO
                     * - UpdateDeletedComment
                     */
                }).finally(() => {
                  setCommentAfterAction(id);
                });
        };
        document.addEventListener('ReportComment', handleReportComment);

        /*
         * Comments reporting - end events
         */

        /*
         * Comments ban - start events
         */

        const banRepository = new BanRepository();
        const handleAddBan = (event) => {
            const detail = event.detail;
            const id = detail.CommentId;
            
            setCommentBeforeAction(id);
            banRepository.saveBan(detail).then(data => {
                document.dispatchEvent(new CustomEvent('AddBanSuccess', {
                    detail: {
                        id,
                        banInfo: data.banInfo,
                    },
                }));
            }).catch(data => {
                dispatchCommentErrorEvent(event.detail, data);
                if (data.commentInfo) {
                    /*
                    * @TODO
                    * - UpdateDeletedComment
                    */
                }
            }).finally(() => {
                setCommentAfterAction(id);
            });
        };
        document.addEventListener('AddBan', handleAddBan);

        const handleAddBanSuccess = (event) => {
            const detail = event.detail;
            const id = detail.id;
            const commentModel = CommentsService.getVisibleCommentsCollection().findById(id);

            if (commentModel) {
                commentModel.set('banInfo', detail.banInfo);
                CommentsService.updateBannedUsersFlag({
                    username: commentModel.get('username'),
                    isUserBanned: true,
                    banInfo: detail.banInfo,
                });
                sendDirectCommentRefreshEvent(id, { id, model: commentModel });
            }
        };
        document.addEventListener('AddBanSuccess', handleAddBanSuccess);

        const handleCancelBan = (event) => {
            const { id, url } = event.detail;

            setCommentBeforeAction(id);
            banRepository.cancel(url).then(() => {
                document.dispatchEvent(new CustomEvent('CancelBanSuccess', {
                    detail: {
                        id,
                    },
                }));
            }).catch(data => {
                dispatchCommentErrorEvent(event.detail, data);
            }).finally(() => {
                setCommentAfterAction(id);
            });
        };
        document.addEventListener('CancelBan', handleCancelBan);

        const handleCancelBanSuccess = (event) => {
            const id = Number(event.detail.id);
            const commentModel = CommentsService.getVisibleCommentsCollection().findById(id);

            if (commentModel) {
                /*
                 * @TODO - update baninfo
                 */
                const username = commentModel.get('username');
                CommentsService.updateBannedUsersFlag({
                    username,
                    isUserBanned: false,
                });
                CommentsService.cancelBanUsersFlag({ username });
                sendDirectCommentRefreshEvent(id, {
                    id,
                    username,
                });
            }
        };
        document.addEventListener('CancelBanSuccess', handleCancelBanSuccess);

        /*
         * Comments ban - end events
         */

        const handleUpdatePendingReplies = (event) => {

          const commentsCollection = CommentsService.getVisibleCommentsCollection();
          const filter = commentsCollection.get('filter');

          switch (filter)
          {
            case 'rating':
            {
              this.liveCommentsTrigger.addClass('hide');
              return;
            }
            case 'date':
            {
              break;
            }
            default:
            {
              return;
            }
          }

          const request = getRepositoryWithParameters();
          request.repository.load(request.parameters).then((data) => {
            CommentsService.getBufferCommentsCollection().fromJSON(data.comments);
            document.dispatchEvent(new CustomEvent('BufferedLiveCommentsSuccess', { detail: { commentsRaw: data.comments, newCommentsCount: (data.newCommentsCount) ? data.newCommentsCount : 0 }}));
          }, () => {});
        };
        document.addEventListener('BufferedLiveComments',
          handleUpdatePendingReplies);

        const handleBufferedLiveCommentsSuccess = (event) => {

          const commentsRaw = event.detail.commentsRaw;
          const options = {
            oldComments: CommentsService
              .getVisibleCommentsCollection()
              .get('comments'),
            newComments: commentsRaw,
          };

          let labelNewComments = CommentsService.labelNewComments(options);

          if (!_.isNil(labelNewComments)) {

            if (CommentsService.isShoutboxMode()) {
              const newCommentsCount = event.detail.newCommentsCount ? event.detail.newCommentsCount : 0;
              labelNewComments.base = newCommentsCount;
            }

            document.dispatchEvent(new CustomEvent('RefreshOnBufferedLiveComments', {
              detail: labelNewComments,
            }));
          }
        };
        document.addEventListener('BufferedLiveCommentsSuccess',
          handleBufferedLiveCommentsSuccess);

        const handleRefreshOnBufferedLiveComments = (event) => {
          const labels = event.detail;
          if (labels.base) {
            this.updateLiveComments(labels.base);
          }
        };
        document.addEventListener('RefreshOnBufferedLiveComments',
          handleRefreshOnBufferedLiveComments);

        /*
         * Live mode shared between regular comments and shoutbox
         */
        if (CommentsService.isLiveEnabled()) {
          setInterval(() => {
            document.dispatchEvent(new CustomEvent('BufferedLiveComments'));
          }, CommentsService.getLiveRepositoryInterval());
        }
    }
    updateLiveComments(updatedPendingRepliesCounter) {

        if (CommentsService.isShoutboxMode())
        {
          const captureUpdateCommentsClick = (event) => {
            event.preventDefault();

            const filters = { type: 'latest', page: 1 };
            CommentsService.setShoutboxParams(filters);

            CommentsService.updateCollection(function(data) {
              /**
               * @TODO
               * verify shoutbox paginator render
               */
              // ShoutboxPaginator.render(data.pager);
            });
          }
          this.liveCommentsTrigger
            .off()
            .on('click', captureUpdateCommentsClick);
        }
        else
        {
          const captureUpdateCommentsClick = (event) => {
            event.preventDefault();

            const models = CommentsService.getBufferredBaseComments();

            models.reverse().forEach((model) => {
              CommentsService.loadFromBuffer(model);
              this.addCommentToTop(model);
            });

            this.liveCommentsTrigger.addClass('hide');
            document.dispatchEvent(new CustomEvent('ClearFiltersNewCount'));
          };

          this.liveCommentsTrigger
            .off()
            .on('click', captureUpdateCommentsClick);
        }

        const liveCommentsMsg = `Zobacz ${ updatedPendingRepliesCounter } ${ pluralVariety(updatedPendingRepliesCounter, 'nowy komentarz', 'nowe komentarze', 'nowych komentarzy') } `;
        this.liveCommentsTrigger.removeClass('hide');
        this.liveCommentsTrigger.html(liveCommentsMsg);
    }
    buildAddCommentView() {
        this.addCommentView = new AddCommentView(this.getModel());
        this.addCommentView.setRootEl($(elements.addCommentView));
        this.addChild(this.addCommentView);
    }
    getActiveFilter() {
        return this.activeFilter;
    }
    toggleModerationMode() {
      this.rootEl.toggleClass('comments-list__moderationMode');
    }
    render(options = {}) {
        this.activeFilter = this.getModel().get('filter');
        // Operations on copy to protect live comments
        this.comments = this.getModel().get('comments').slice(0);

        let bufferedComments = [];
        const isPaginationEnabled = this.comments.length > CommentsService.getMoreRenderLimit();
        const loadMore = $(elements.loadMore);

        /**
         * Add sponsor comments
         *
         * @param {*} model - comment model
         */
        let i = 1;
        let rotation = window.localStorage.getItem('sponsor-rotation');
        rotation = Number(rotation ? rotation : 0);

        const playerCommentView = new SponsorPlayerComment();
        const iplaCommentView = new SponsorIplaComment();
        const sponsorTotoComment = new SponsorTotoComment();

        const doesPlayerIplaSectionExists = playerCommentView.exists() || iplaCommentView.exists();
        const doesFortunaSectionExists = sponsorTotoComment.exists();

        const length = this.comments.length;

        const user = siteModel.get('User');

        const renderPlayerSection = () => {
          const playerRenderCommentView = new SponsorPlayerComment();
          if (playerCommentView.exists()) {
            playerRenderCommentView.render();
            this.rootEl.append(playerRenderCommentView.getRootEl());
          }
        }

        const renderIplaSection = () => {
          const iplaRenderCommentView = new SponsorIplaComment();
          if (iplaCommentView.exists()) {
            iplaRenderCommentView.render();
            this.rootEl.append(iplaRenderCommentView.getRootEl());
          }
        }

        const renderFortunaSection = () => {
          const fortunaRenderCommentView = new SponsorTotoComment();
          if (sponsorTotoComment.exists()) {
            fortunaRenderCommentView.render();
            this.rootEl.append(fortunaRenderCommentView.getRootEl());
          }
        }

        const createView = (model) => {
          const view = this.addComment(model);
          if (view) {
            this.rootEl.append(view);
          }

          if (!CommentsService.isShoutboxMode()) {
            /**
             * sponsor comments places
             * - player - after first comment
             * - toto - before last, only when there is more than 20 comments
             */
            if (i === 1) {
              if (doesPlayerIplaSectionExists && doesFortunaSectionExists) {
                if (!rotation) {
                  renderFortunaSection();
                } else {
                  renderPlayerSection();
                  renderIplaSection();
                }
              } else {
                if (doesPlayerIplaSectionExists) {
                  renderPlayerSection();
                  renderIplaSection();
                }
                if (doesFortunaSectionExists) {
                  renderFortunaSection();
                }
              }
            }
            if ((length > 10) && (i === (length - 1))) {
               if (doesPlayerIplaSectionExists && doesFortunaSectionExists) {
                if (rotation) {
                  renderFortunaSection();
                } else {
                  renderPlayerSection();
                  renderIplaSection();
                }
              } else {
                if (doesPlayerIplaSectionExists) {
                  renderPlayerSection();
                  renderIplaSection();
                }
                if (doesFortunaSectionExists) {
                  renderFortunaSection();
                }
              }
            }
          } else {
                if (i === 3) {
                    renderFortunaSection();
                }
          }
          i++;
        };

        this.rootEl.empty();
        this.rootEl.prepend(this.liveCommentsTrigger);

        if (length) {
            const renderStep = CommentsService.getMoreRenderStep();

            if (isPaginationEnabled && !CommentsService.isShoutboxMode()) {
              bufferedComments = this.comments.splice(renderStep,
                this.comments.length - renderStep);
              this.lastVisibleId = _.last(this.comments).get('id');
              loadMore.removeClass('fn-hidden');
            }

            this.comments.forEach(createView);
            this.rootEl.removeClass('comments-list--loading');

            if (isPaginationEnabled && !CommentsService.isShoutboxMode()) {
              loadMore.removeClass('c-comments__loadMore--loading')
                .find('button').on('click', (event) => {
                    loadMore.addClass('c-comments__loadMore--loading');
                    this.comments = bufferedComments.splice(0, renderStep);
                    this.comments.forEach(createView);
                    this.lastVisibleId = _.last(this.comments).get('id');
                    loadMore.removeClass('c-comments__loadMore--loading');
                    if (!bufferedComments.length) {
                      loadMore.addClass('fn-hidden');
                    }
                });
            }

            document.dispatchEvent(new CustomEvent('CommentsViewRendered', {}));

            rotation = rotation ? 0 : 1;
            window.localStorage.setItem('sponsor-rotation', rotation);

            /*
             * commented because double backend request
             * document.dispatchEvent(new CustomEvent('BufferedLiveComments'));
             */

        } else {
            this.rootEl.html(this.noCommentsYetEl);
            this.rootEl.removeClass('comments-list--loading');
        }
    }
    addComment(model) {
        const abstractComment = new AbstractComment(model);
        abstractComment.render();

        const commentView = abstractComment.getCommentView();

        if (commentView) {
          this.addChild(commentView);
          commentView.render();
          return abstractComment.getRootEl();
        }
        return false;
    }
    addCommentToTop(model) {
        const rootEl = this.addComment(model);
        if (rootEl) {
          rootEl.addClass('user-comment--recent');
          setTimeout(() => {
            rootEl.removeClass('user-comment--recent');
          }, 15000);
          this.rootEl
            .find(elements.liveBanner)
            .after(rootEl);
        }
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comments-view.js